<template>
<div
	class="mega-menu">
	<div class="mega-menu-mask"></div>
	<div class="mega-menu-wrapper" v-mega-click-outside="handleClickOutside">
		<div class="mega-menu-container">
			<div class="row m-0">
				<!-- This Event -->
				<div class="col-6 col-sm-4 col-md-2 section-link-area" v-if="isInEventPage">
					<div class="section-name">{{ $t('This Event') }}</div>
					<div class="section-links">
						<div class="menu-link-item"
							@click="returnToAgendaList()">
							{{ $t('agenda') }}
						</div>
						<div class="menu-link-item"
							@click="showChangeRole()"
							v-if="isInNowPage && participantRoles.length > 1">
							{{ $t('Change role') }}
						</div>
						<div class="menu-link-item"
							:class="{ 'active-link' : locationName === 'EventFiles'}"
							@click="goToEventPage('event_files')"
							v-if="isHasFile">
							{{ $t('Other Papers') }}
						</div>
						<div class="menu-link-item"
							:class="{ 'active-link' : locationName === 'Messages'}"
							@click="goToEventPage('event_message')"
							v-if="isMessagesEnabled">
							{{ $t('messages') }}
						</div>
						<div class="menu-link-item"
							:class="{ 'active-link' : locationName === 'EventLeave'}"
							@click="goToEventPage('event_leave')"
							v-if="isLeaveEnabled">
							{{ $t('Leaves') }}
						</div>
						<div class="menu-link-item"
							:class="{ 'active-link' : locationName === 'LandingPage'}"
							@click="goToEventPage('landing_page')"
							v-if="isLandingPageEnabled">
							{{ $t('Landing page') }}
						</div>
						<div class="menu-link-item"
							@click="showQrEvent()"
							v-if="isEventQREnabled">
							{{ $t('QR for the event') }}
						</div>
						<hr v-if="(isSecretaryEvent || isAdminEvent || isEditorialEvent || isSetAgenda || isParticipantsRole || isDisplaysRole)">
						<div class="menu-link-item font-weight-bold"
							:class="{ 'active-link' : locationName === 'EventDetails'}"
							@click="isAdminEvent ? goToEventPage('event_detail') : false"
							v-if="isAdminEvent || isDisplaysRole || isSecretaryEvent || isEditorialEvent || isSetAgenda || isParticipantsRole">
							{{ $t('Event setup') }}
						</div>
						<div class="menu-link-item"
							:class="{ 'active-link' : locationName === 'EventSettingDisplay'}"
							@click="goToEventPage('event_displays')"
							v-if="isAdminEvent || isDisplaysRole">
							{{ $t('displays') }}
						</div>
						<div class="menu-link-item"
							:class="{ 'active-link' : locationName === 'EventReport'}"
							@click="goToEventPage('event_report')"
							v-if="isSecretaryEvent || isAdminEvent">
							{{ $t('reports') }}
						</div>
						<div class="menu-link-item"
							:class="{ 'active-link' : locationName === 'EventSuggestionsProcessing'}"
							@click="goToEventPage('event_suggestion_processing')"
							v-if="isSecretaryEvent || isEditorialEvent">
							{{ $t('suggestionProcessing') }}
						</div>
						<div class="menu-link-item"
							:class="{ 'active-link' : locationName === 'EventAgenda'}"
							@click="goToEventPage('event_agenda')"
							v-if="isAdminEvent || isSetAgenda">
							{{ $t('Set Agenda') }}
						</div>
						<div class="menu-link-item"
							:class="{ 'active-link' : locationName === 'EventParticipant'}"
							@click="goToEventPage('event_participants')"
							v-if="isAdminEvent || isSecretaryEvent || isParticipantsRole">
							{{ $t('Participants page') }}
						</div>
						<div class="menu-link-item"
							:class="{ 'active-link' : locationName === 'EventInvitation'}"
							@click="goToEventPage('event_invitation')"
							v-if="isRegistrationEvent">
							{{ $t('Registration') }}
						</div>
					</div>
				</div>

				<!-- User -->
				<div class="col-6 col-sm-4 col-md-2 section-link-area">
					<div class="section-name">{{ $t('Your profile') }}</div>
					<div class="section-links">
						<div class="menu-link-item">
							<router-link to="/events">{{ $t('Your events') }}</router-link>
						</div>
						<div class="menu-link-item">
							<router-link to="/user/profile">{{ $t('userProfile') }}</router-link>
						</div>
						<div class="menu-link-item" @click="showUserManual()">
							{{ $t('MyMeet knowledge') }}
						</div>
					</div>
				</div>

				<!-- Client -->
				<div class="col-6 col-sm-4 col-md-2 section-link-area" v-if="isUserClient || isUserSuperAdmin">
					<div class="section-name">{{ $t('Client') }}</div>
					<div class="section-links">
						<div class="menu-link-item">
							<router-link to="/admin/events">{{ $t('manageEvents') }}</router-link>
						</div>
						<div class="menu-link-item">
							<router-link to="/theme">{{ $t('My Theme') }}</router-link>
						</div>
					</div>
				</div>

				<!-- Super Admin -->
				<div class="col-6 col-sm-4 col-md-2 section-link-area" v-if="isUserSuperAdmin">
					<div class="section-name">{{ $t('Super Admin') }}</div>
					<div class="section-links">
						<div class="menu-link-item">
							<router-link to="/admin/user-manuals">{{ $t('User manuals') }}</router-link>
						</div>
						<div class="menu-link-item">
							<router-link to="/admin/clients">{{ $t('clients') }}</router-link>
						</div>
						<div class="menu-link-item">
							<router-link to="/admin/users">{{ $t('Super Admin') }}</router-link>
						</div>
						<div class="menu-link-item">
							<router-link to="/admin/statistics">{{ $t('statistics') }}</router-link>
						</div>
						<div class="menu-link-item">
							<router-link to="/admin/announcements">{{ $t('Announcements') }}</router-link>
						</div>
						<div class="menu-link-item">
							<router-link to="/admin/inactive-users">{{ $t('Inactive Users') }}</router-link>
						</div>
					</div>
				</div>

				<!-- Other -->
				<div class="col-6 col-sm-4 col-md-2 section-link-area">
					<div class="section-name">{{ $t('Other') }}</div>
					<div class="section-links">
						<div class="menu-link-item" @click="goToPrivacyPage()">
							{{ $t('privacyPolicy') }}
						</div>
						<div class="menu-link-item">
							{{ $t('Version') }} {{ appVersion }}
						</div>
						<div class="menu-link-item text-danger pointer" @click="showLogoutConfirmation()">
							{{ $t('logout') }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { checkRoleOwned, isJsonString, isSettingEventCheckinRequired } from '@/lib/helper';

export default {
	name: 'MainMegaMenu',
	components: {
	},
	props: {
		show: {
			type: Boolean,
			default: () => false,
		},
		participant: {
			type: Object,
			default: () => null,
		},
	},
	data() {
		return {
			isShowModalChangeRole: false,
			isShowModalLogout: false,
			isShowUserManual: false,
		};
	},
	sockets: {
	},
	mounted() {},
	created() {},
	destroyed() {},
	beforeDestroy() {
	},
	computed: {
		...mapGetters({
			user: 'user',
			currentRole: 'now/currentRole',
			event: 'now/event',
			agenda: 'now/agenda',
			activeAgenda: 'now/activeAgenda',
		}),
		appVersion() {
			return this.$store.getters.appVersion;
		},
		isUserClient() {
			return this.user && this.user.role === 'client';
		},
		isUserSuperAdmin() {
			return this.user && this.user.role === 'super_admin';
		},
		location() {
			const location = this.$store.getters.location;
			return location;
		},
		locationName() {
			const locationName = this.location.to.name;
			return locationName;
		},
		eventSlug() {
			return this.$route.params.eventSlug;
		},
		isInEventPage() {
			const isIn = this.eventSlug !== undefined;
			return isIn;
		},
		isInNowPage() {
			const isIn = this.locationName === 'EventNow';
			return isIn;
		},
		eventSettings() {
			return this.event && this.event.settings ? JSON.parse(this.event.settings) : false;
		},
		isLeaveEnabled() {
			let isEnabled = false;
			if (this.eventSettings && this.eventSettings.is_leave_request_enabled !== undefined) isEnabled = this.eventSettings.is_leave_request_enabled;
			return isEnabled;
		},
		isMessagesEnabled() {
			let isEnabled = false;
			if (this.eventSettings && this.eventSettings.is_messages_enabled !== undefined) isEnabled = this.eventSettings.is_messages_enabled;
			return isEnabled;
		},
		isLanguageSwitcherEnabled() {
			let isEnabled = false;
			if (this.eventSettings && this.eventSettings.is_language_switcher_enabled !== undefined) isEnabled = this.eventSettings.is_language_switcher_enabled;
			return isEnabled;
		},
		isLandingPageEnabled() {
			let isEnabled = false;
			if (this.eventSettings && this.eventSettings.landing_page && this.eventSettings.landing_page.is_enabled !== undefined) {
				isEnabled = this.eventSettings.landing_page.is_enabled;
			}
			return isEnabled;
		},
		isHasFile() {
			let isEnabled = false;
			if (this.event && this.event.total_file > 0) isEnabled = true;
			return isEnabled;
		},
		participantRoles() {
			let roles = [];
			if (this.participant && isJsonString(this.participant.roles)) roles = JSON.parse(this.participant.roles);
			return roles;
		},
		isAdminEvent() {
			return this.participant ? checkRoleOwned(this.participant, 'admin') : false;
		},
		isModeratorEvent() {
			return this.participant ? checkRoleOwned(this.participant, 'moderator') : false;
		},
		isSecretaryEvent() {
			return this.participant ? checkRoleOwned(this.participant, 'secretary') : false;
		},
		isEditorialEvent() {
			return this.participant ? checkRoleOwned(this.participant, 'editorial') : false;
		},
		isRegistrationEvent() {
			return this.participant ? checkRoleOwned(this.participant, 'registration') : false;
		},
		isSetAgenda() {
			return this.participant ? checkRoleOwned(this.participant, 'set_agenda') : false;
		},
		isParticipantsRole() {
			return this.participant ? checkRoleOwned(this.participant, 'participants') : false;
		},
		isDisplaysRole() {
			return this.participant ? checkRoleOwned(this.participant, 'displays') : false;
		},
		isEventQREnabled() {
			return this.event && this.participant ? isSettingEventCheckinRequired(this.event) : false;
		},
	},
	methods: {
		...mapActions({
			setAgenda: 'now/setAgenda',
		}),
		handleClickOutside() {
			this.close();
		},
		close() {
			this.$emit('close');
		},
		showLogoutConfirmation() {
			this.close();
			this.$emit('showModalLogoutConfirmation');
		},
		goToPrivacyPage() {
			window.open('https://personvern.lomedia.no', '_blank');
		},
		showChangeRole() {
			this.close();
			this.$emit('showChangeRole');
		},
		showUserManual() {
			this.close();
			this.$emit('showUserManual');
		},
		goToEventPage(page) {
			const eventSlug = this.eventSlug;
			if (eventSlug !== undefined) {
				switch (page) {
				case 'event_message':
					this.$router.push({ name: 'Messages', params: { eventSlug } }).then(() => {}).catch(() => {});
					break;
				case 'event_message_leave':
					this.$router.push({ name: 'Messages', params: { eventSlug }, hash: '#leave' }).then(() => {}).catch(() => {});
					break;
				case 'event_leave':
					this.$router.push({ name: 'EventLeave', params: { eventSlug } }).then(() => {}).catch(() => {});
					break;
				case 'event_files':
					this.$router.push({ name: 'EventFiles', params: { eventSlug } }).then(() => {}).catch(() => {});
					break;
				case 'event_detail':
					this.$router.push({ name: 'EventDetails', params: { eventSlug } }).then(() => {}).catch(() => {});
					break;
				case 'event_agenda':
					this.$router.push({ name: 'EventAgenda', params: { eventSlug } }).then(() => {}).catch(() => {});
					break;
				case 'event_participants':
					this.$router.push({ name: 'EventParticipant', params: { eventSlug } }).then(() => {}).catch(() => {});
					break;
				case 'event_suggestion_processing':
					this.$router.push({ name: 'EventSuggestionsProcessing', params: { eventSlug } }).then(() => {}).catch(() => {});
					break;
				case 'event_report':
					this.$router.push({ name: 'EventReport', params: { eventSlug } }).then(() => {}).catch(() => {});
					break;
				case 'event_permission':
					this.$router.push({ name: 'EventPermission', params: { eventSlug } }).then(() => {}).catch(() => {});
					break;
				case 'event_invitation':
					this.$router.push({ name: 'EventInvitation', params: { eventSlug } }).then(() => {}).catch(() => {});
					break;
				case 'event_displays':
					this.$router.push({ name: 'EventSettingDisplay', params: { eventSlug } }).then(() => {}).catch(() => {});
					break;
				case 'landing_page':
					this.$router.push({ name: 'LandingPage', params: { eventSlug } }).then(() => {}).catch(() => {});
					break;
				default:
					break;
				}
			}
		},
		returnToAgendaList() {
			this.close();
			this.setAgenda(null);

			if (this.locationName !== 'EventNow') {
				this.$router.push({ name: 'EventNow', params: { eventSlug: this.eventSlug } }).then(() => {}).catch(() => {});
			}
		},
		showQrEvent() {
			this.close();
			this.$emit('showQrEvent');
		},
	},
	watch: {
		$route() {
			// Close mega menu if route changed
			this.close();
		},
	},
};
</script>
